import { Stack, TableCell, TableRow, Typography } from "@mui/material"
import get from "lodash/get"
import { ContentTableColumn, DataModel } from "@tc/ui-dfe/utils/types"

interface ContentTableDataRowProps {
  columns: ContentTableColumn[]
  data: DataModel
  rowIndex: number
}

export const DesktopRow = ({
  data,
  columns,
  rowIndex,
}: ContentTableDataRowProps) => {
  return (
    <TableRow hover data-testid="test-desktopRowRequests">
      {columns.map((col, colIndex) => {
        if (col.customCell) {
          return col.customCell(data, rowIndex)
        }
        return (
          <TableCell key={`${rowIndex}-${colIndex}`}>
            <Typography>
              {get(data, col.valueProp) || col.fallbackValue}
            </Typography>
          </TableCell>
        )
      })}
    </TableRow>
  )
}

export const MobileRow = ({
  data,
  columns,
  rowIndex,
}: ContentTableDataRowProps) => {
  return (
    <TableRow hover data-testid="test-mobileRowRequests" key={data.id}>
      <TableCell
        sx={{
          px: {
            xs: 1.5,
            sm: 2.5,
          },
          py: 2,
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          key={data.id}
          justifyContent="space-between"
        >
          {columns
            .filter((col) => col.mobileColumn)
            .map((col, colIndex) => {
              if (col.mobileCustomCell) {
                return col.mobileCustomCell(data, rowIndex)
              }
              const key = col.valueProp as keyof DataModel
              if (colIndex === 0) {
                return (
                  <Stack flexGrow={1} spacing={0.5} key={colIndex}>
                    <Typography noWrap sx={{ lineHeight: 1.5 }}>
                      {data[key] || col.fallbackValue}
                    </Typography>
                  </Stack>
                )
              }

              return (
                <Stack key={colIndex}>
                  <Typography noWrap sx={{ lineHeight: 1.5 }}>
                    {data[key] || col.fallbackValue}
                  </Typography>
                </Stack>
              )
            })}
        </Stack>
      </TableCell>
    </TableRow>
  )
}
